import React from "react";

import Bugsnag from "@bugsnag/js";
import { twMerge } from "tailwind-merge";

import useAuthentication from "hooks/useAuthentication";
import { useGlobalState } from "hooks/useGlobalState";
import { fetchApi } from "utils/baseFetcher";

import style from "./style.module.scss";

type Props = {
  title: string;
  onClose: any;
  onUndo: any;
  type: string;
  id: string;
};

const UndoMuteContent = ({ title, onClose, onUndo, id, type }: Props) => {
  const [_, setShowFeedSettings] = useGlobalState(
    "showFeedSettingsModal",
    false
  );
  const { account } = useAuthentication();

  const deleteMutedItem = async () => {
    try {
      if (["account", "company", "entity"].includes(type)) {
        await fetchApi(`/api/v2/muted-items/${id}`, {
          method: "DELETE",
        });
      } else {
        await fetchApi(`/api/v2/accounts/${account?.id}`, {
          method: "PATCH",
          body: JSON.stringify({
            data: {
              attributes: {
                "muted-contents": { [type]: false },
              },
              id: account?.id,
              relationships: {},
              type: "accounts",
            },
          }),
        });
      }

      onUndo(type);
    } catch (error: any) {
      Bugsnag.notify(error);
    }
  };

  return (
    <div className={style.publicationMuteContainer}>
      <div className="text-[13px] flex-1">
        <h5>Content Removed</h5>
        <div>
          You will no longer see content by <strong>{title}</strong> on your
          feed
        </div>
        <div>
          you can always visit your{" "}
          <span
            onClick={() => {
              setShowFeedSettings(true);
            }}
            className={twMerge(
              "border-none text-smart-teal hover:text-[#1d8988] cursor-pointer"
            )}
          >
            feed settings
          </span>{" "}
          to manage your muted Insight Providers list later.
        </div>
      </div>
      <div className="flex text-[14px]">
        <button
          onClick={deleteMutedItem}
          className={twMerge(
            "px-[12px] py-[6px] mr-[5px]",
            "rounded-full border-0 bg-smart-teal hover:bg-smart-teal-500 text-white"
          )}
        >
          Undo
        </button>
        <button
          onClick={onClose}
          className="border-0 bg-transparent text-[#3a3a3c]"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default UndoMuteContent;
